import script from "./CustomerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerPage.vue?vue&type=script&setup=true&lang=js"

import "./CustomerPage.vue?vue&type=style&index=0&id=102b1a81&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-102b1a81"]])

export default __exports__